import * as yup from "yup";

export const RegionsValidation = yup.object().shape({
    name: yup
        .string()
        .required("Region name is required")
        .min(2, "Region name must be at least 2 characters")
        .max(50, "Region name must not exceed 50 characters")
        .matches(/^[a-zA-Z\s]+$/, "Region name can only contain letters and spaces")
        .trim(),
    
    code: yup
        .string()
        .required("Region code is required")
        .min(2, "Region code must be at least 2 characters")
        .max(10, "Region code must not exceed 10 characters")
        .matches(/^[A-Z0-9]+$/, "Region code can only contain uppercase letters and numbers")
        .transform((value) => value?.toUpperCase())
        .trim(),
    
    is_active: yup
        .boolean()
        .default(true)
}); 